<template>
    <form class="form" autoComplete="off" :id=formName :name=formName noValidate="" method="POST">
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">First name</label>
            <div class="col-lg-9">
                <input class="form-control" type="text" value="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Last name</label>
            <div class="col-lg-9">
                <input class="form-control" type="text" value="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Email</label>
            <div class="col-lg-9">
                <input class="form-control" type="email" value="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Company</label>
            <div class="col-lg-9">
                <input class="form-control" type="text" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Website</label>
            <div class="col-lg-9">
                <input class="form-control" type="url" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Time Zone</label>
            <div class="col-lg-9">
                <select id="user_time_zone" class="form-control" size="0">
                    <option value="Hawaii">(GMT-10:00) Hawaii</option>
                    <option value="Alaska">(GMT-09:00) Alaska</option>
                    <option value="Pacific Time (US &amp; Canada)">(GMT-08:00) Pacific Time (US &amp; Canada)</option>
                    <option value="Arizona">(GMT-07:00) Arizona</option>
                    <option value="Mountain Time (US &amp; Canada)">(GMT-07:00) Mountain Time (US &amp; Canada)</option>
                    <option value="Central Time (US &amp; Canada)">(GMT-06:00) Central Time (US &amp; Canada)</option>
                    <option value="Eastern Time (US &amp; Canada)">(GMT-05:00) Eastern Time (US &amp; Canada)</option>
                    <option value="Indiana (East)">(GMT-05:00) Indiana (East)</option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Username</label>
            <div class="col-lg-9">
                <input class="form-control" type="text" value="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Password</label>
            <div class="col-lg-9">
                <input class="form-control" type="password" value="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label">Confirm</label>
            <div class="col-lg-9">
                <input class="form-control" type="password" value="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-lg-3 col-form-label form-control-label"></label>
            <div class="col-lg-9">
                <input type="reset" v-if="showResetBtn" class="btn btn-secondary mr-2" value="Cancel" />
                <input type="button" class="btn btn-primary" :value="submitBtnText" />
            </div>
        </div>
    </form>
</template>
<script>
export default {
    props: {
        formName: "formUserInfo",
        showResetBtn: true,
        submitBtnText: {
            type: String,
            default: "Submit"            
        }
    }
};
</script>
